import React from 'react';
import './About.css';
// import backgroundImage from '../../assets/images/fone2.jpg';

const About = () => {
  return (
    <section className="about">
      <div className="about__overlay"></div>
      <div className="about__background"></div>
      <div className="container">
        <div className="about__content">
          <h2 className="about__title">О нас</h2>
          <div className="about__text">
            <p>
              Наша группа компаний представляет собой специальное объединение для обслуживания 
              клиентов по смежным с основной деятельностью услугам. Много лет работая в гостиничном 
              бизнесе, мы развили сеть отелей и мини гостиниц по всей территории России, а так же 
              активно участвуем в оптово-розничной торговле строительных материалов.
            </p>
            <p>
              Утраченные документы по покупке товара или услуги – не редкость, а наш сервис стал 
              решением подобных проблем. Подтверждение расходов за проживание в гостинице или отчет 
              по строительной смете – все это мы делаем, причем быстро, грамотно, конфиденциально!
            </p>
            <p>
              Территориально мы работаем в Челябинске, но сможем помочь в подобных ситуациях 
              и в других городах России (уточняйте доступные у оператора).
            </p>
          </div>
          <a href="#contact" className="about__button">
            <span className="about__button-icon">→</span>
            <span className="about__button-text">Заказать документы</span>
          </a>
        </div>
      </div>
    </section>
  );
};

export default About;